export const convertOptions = (options) => {
  return options.map((option, index) => ({
    key: index,
    text: option,
    value: option,
  }));
};

export const convertOptionsToLowerCase = (options) => {
  return options.map((option, index) => ({
    key: index,
    text: option?.toUpperCase(),
    value: option?.toLowerCase(),
  }));
};

export const downloadFile = (blob, fileName) => {
  const dataUri = URL.createObjectURL(blob);
  const downloadLinkElement = document.createElement("a");
  downloadLinkElement.setAttribute("href", dataUri);
  downloadLinkElement.setAttribute("download", fileName);
  downloadLinkElement.style.display = "none";

  document.body.appendChild(downloadLinkElement);
  downloadLinkElement.click();
  document.body.removeChild(downloadLinkElement);
  URL.revokeObjectURL(dataUri);
};